import * as React from 'react';
import { connect } from 'react-redux';
import { requestAPIActions } from 'loopback-react-request';
import { ConfigurationModel, PlateSurfaceDefaultModel } from 'franke-trough-dependencies';

import { GlobalPrivateState, NavigationConfigurationKeys, formatMessage, PlateSurfaceKeys } from 'src/api';
import { Accordion } from 'src/app/Container';
import { ConfigurationHeader, ConfigurationPartProps, ConfigurationPart } from 'src/app/Partials';

import {
  Colour,
  ColourBottomSide,
  ElementNext,
} from 'src/app/Partials/Configuration/Inputs';

import MESSAGES from '../ConfigurationDetail.messages';

import 'rc-slider/assets/index.css';
import './ConfigurationSurface.page.scss';
import { isConfigurationEditable } from 'src/redux/utils.redux';

export interface ConfigurationSurfacePageProps {
  configuration: GlobalPrivateState['configuration'];
  dispatch: any;
  validated: GlobalPrivateState['validatedConfiguration'];
}

export class ConfigurationSurface extends React.Component<ConfigurationSurfacePageProps, any> {
  componentDidMount() {
    this.dispatchDefaults();
  }

  public render() {
    return (
      <div className="page-configuration-surface">
        <div className="col-12">
          <ConfigurationHeader
            icon="paint-palette"
            title={formatMessage(MESSAGES.colourTitle)}
          />
        </div>
        <div className="configuration-wrap pl-5 pr-5 pt-1">
          <div className="col-12 pb-3 pl-0 pr-0">
            <Accordion>
              {this.surfaceParts.map((props, index) => {
                const key = `configuration_surface_${index}`;
                return (
                  <ConfigurationPart
                    key={key}
                    {...props}
                  />
                );
              })}
            </Accordion>
          </div>
          <div className="col-12 pt-4 text-center">
            <ElementNext id={NavigationConfigurationKeys.surface} />
          </div>
        </div>
      </div>
    );
  }
   
  private get defaults(): PlateSurfaceDefaultModel | undefined {
    const { configuration } = this.props;
    const confDefaults = configuration.result && configuration.result && configuration.result.defaults;
    return confDefaults && confDefaults.surface;
  }

  private dispatchDefaults() {
    const { configuration } = this.props;

    if (!isConfigurationEditable()) { return; }
    
    if (configuration && configuration.result && !configuration.result.surface) {
      const defaults = this.defaults;
      if (defaults) {
        const data: ConfigurationModel['surface'] = {
          color: defaults.color.default,
          gelCoat: defaults.gelCoat.default,
        };

        this.props.dispatch(requestAPIActions.load(
          'configuration',
          {
            url: `/Configurations/${configuration.result.id}`,
            options: {
              method: 'PATCH',
              data: {surface: data},
            },
          },
          true
        ));
      }
    }
  }
    
  private get surfaceParts(): ConfigurationPartProps[] {
    const validated = this.props.validated.byItem.surface;    
    return [{
      btnName: formatMessage(MESSAGES.color),
      component: Colour,
      error: [
        validated && validated.color || false,
      ] || undefined,
      id: PlateSurfaceKeys.Color,
    }, {
      btnName: formatMessage(MESSAGES.colorBottomSide),
      component: ColourBottomSide,
      error: [
        validated && validated.gelCoat || false,
      ] || undefined,
      id: PlateSurfaceKeys.GelCoat,
    }];
  }
}

export const ConfigurationSurfacePage = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration, 
  validated: state.validatedConfiguration,
}))(ConfigurationSurface);

export default ConfigurationSurfacePage;
